import { parseNumber } from '#features/csvImport/parsing/utils.ts';

export const parseCoordinates = (value: string) => {
    const [latitudeRaw = '', longitudeRaw = ''] = value.split(',');
    if (!latitudeRaw.trim() || !longitudeRaw.trim()) {
        return { latitude: undefined, longitude: undefined };
    }

    const latitude = parseNumber(latitudeRaw);
    const longitude = parseNumber(longitudeRaw);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return { latitude: undefined, longitude: undefined };
    }

    return { latitude, longitude };
};
